import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import ReactAnimatedWeather from "react-animated-weather";
import CurrentDate from "./CurrentDate";
import Units from "./Units";
import WeatherForecast from "./WeatherForecast";
import { weatherMap } from "./utils/constants";
import "./Weather.css";

export default function Weather() {
  // add an event to the form
  // create the event function
  // add an onchange event to the type area
  // the the value
  // make an ajax call
  let [city, setCity] = useState("London");

  let [weatherDetail, setWeatherDetail] = useState({});

  const apiRequest = useCallback(() => {
    let url = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=193afd01b965f6a8b5609e9278812cbe&units=metric`;

    axios.get(url).then(function (response) {
      console.log(response, "+++");
      setWeatherDetail({
        temperature: Math.round(response.data.main.temp),
        humidity: Math.round(response.data.main.humidity),
        date: new Date(response.data.dt * 1000),
        description: response.data.weather[0].description,
        wind: Math.round(response.data.wind.speed),
        city: response.data.name,
        iconId: response.data.weather[0].icon,
        iconUrl: `http://openweathermap.org/img/wn/${response.data.weather[0].icon}@2x.png`,
        lon: response.data.coord.lon,
        lat: response.data.coord.lat,
      });
    });
  }, [city]);

  function handleSubmit(event) {
    event.preventDefault();
    apiRequest();
  }

  // Call apiRequest after component has been mounted to the DOM
  useEffect(() => {
    apiRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // empty array means call just once(first render)

  function updateCity(response) {
    // Add debounce here: Only update city state after a new milliseconds.
    setCity(response.target.value);
  }

  return (
    <div className="list">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-9">
            <input
              type="search"
              className="boxes typearea"
              placeholder="Enter city..."
              autoFocus="on"
              onChange={updateCity}
            />
          </div>

          <div className="col-3">
            <input
              type="submit"
              value="Search"
              className="btn-primary boxes btn"
            />
          </div>
        </div>
      </form>
      <h1 className="city">{weatherDetail.city ?? city}</h1>

      <div>
        {weatherDetail.date ? <CurrentDate date={weatherDetail.date} /> : null}
        <p>{weatherDetail.description}</p>
      </div>
      <div className="row info-section">
        <div className="col-6 temperature-icon">
          {weatherDetail.iconId ? (
            <ReactAnimatedWeather
              icon={weatherMap[weatherDetail.iconId]}
              animated={true}
              size={64}
            />
          ) : null}
          <Units weatherDetail={weatherDetail} />
        </div>
        <div className="col-6">
          <ul>
            <li>Precipitation: 19%</li>
            <li>humidity:{weatherDetail.humidity}</li>
            <li>Wind: {weatherDetail.wind}Km/h</li>
          </ul>
        </div>
      </div>
      {weatherDetail.lon ? (
        <WeatherForecast
          city={weatherDetail.city}
          lon={weatherDetail.lon}
          lat={weatherDetail.lat}
        />
      ) : null}
    </div>
  );
}
